import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const titleScreen: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W' },
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        {
          track: 'WE',
          entrance: 'E',
          vehicle: { type: 'npc', wagons: 8 },
        },
      ],
      'fill',
    ),
    [],
    padRow(
      [
        {
          track: 'WE',
          entrance: 'W',
          vehicle: { type: 'npc', wagons: 8 },
        },
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        { track: 'WE', exit: 'E' },
      ],
      'fill',
    ),
  ],
  goal: { sequence: ['PLACEHOLDER'] },
}
